<template>
<div class='afficheSidebar'>

	<!-- 左侧导航栏 -->
	<div class='afs-menu'>
		<!-- 段落 -->
		<template v-for='(item,index) in orr_menu'>
			<div :key='item.id' class='afs-menu-model'>
				<div class='afs-menu-mod-title font-16 color-body fontweight-bo'>{{item.title}}</div>
				<template v-for='(obj,seq) in item.data'>
					<div :key='obj.id' 
						 :class="{'afs-menu-mod-line font-14 bg-hoer-shallow':true, 'bgcolor-shallow':obj.choose, 'color-prompt-deep':!obj.choose}" 
						 :data-index='index' 
						 :data-seq='seq' 
						 @click='func_menu' 
						 >{{obj.name}}
					</div>
				</template>
			</div>
		</template>
	</div>
	
</div>
</template>
<script>
export default {
	name: 'afficheSidebar',
	props: {},
	data() {
		return {
			orr_menu: [
				{
					title: '网站公告',
					data: [
						{name:'我们开工啦!!', choose:true},
						// {name:'信封类产品19号暂停接单', choose:false},
						{name:'新增房卡套_筷子套标准刀模', choose:false},
						{name:'国庆放假通知', choose:false},
					]
				},
				{
					title: '印刷咨询',
					data: [
						{name:'做好印前准备 = 省钱? 印前设计必须注意的问题清单 | 干货', choose:false},
						{name:'胶印油墨需要关注的五大技术指标', choose:false},
						{name:'经验分享 | 潮湿天气来了，谈谈装订铁丝的防锈存储方法', choose:false},
						{name:'【印刷技术】水性油墨该怎么用？', choose:false},
					]
				}
			],
		}
	},
	methods: {
		func_menu(event) {
		}
	}
}
</script>
<style scoped>
@media only screen and (min-width:480px){
.afs-menu {
	width:270px;
}
.afs-menu-model {
	background:#ffffff;
	width:100%; margin-bottom:10px;
	box-sizing:border-box; padding-bottom:10px;
	border-radius:3px;
}
.afs-menu-mod-title {
	width:100%;
	box-sizing:border-box; padding:14px 0;
	text-indent:16px;
	border-bottom:1px solid #f0f2f5;
}
.afs-menu-mod-line {
	width:100%; margin-bottom:6px;
	text-overflow:ellipsis; white-space:nowrap; overflow:hidden;
	box-sizing:border-box; padding:10px 4px 10px 26px;
	border-radius:4px; overflow:hidden;
	cursor:pointer;
	transition: all 0.2s ease-in-out 0s;
}
}
@media only screen and (max-width:480px){
.afs-menu {
	display: none;
}
.afs-menu-model {
	background:#ffffff;
	width:100%; margin-bottom:10px;
	box-sizing:border-box; padding-bottom:10px;
	border-radius:3px;
}
.afs-menu-mod-title {
	width:100%;
	box-sizing:border-box; padding:14px 0;
	text-indent:16px;
	border-bottom:1px solid #f0f2f5;
}
.afs-menu-mod-line {
	width:100%; margin-bottom:6px;
	text-overflow:ellipsis; white-space:nowrap; overflow:hidden;
	box-sizing:border-box; padding:10px 4px 10px 26px;
	border-radius:4px; overflow:hidden;
	cursor:pointer;
	transition: all 0.2s ease-in-out 0s;
}
}
</style>



// WEBPACK FOOTER //
// src/components/afficheSidebar/afficheSidebar.vue